import { render, staticRenderFns } from "./MatchingLedgerItem.vue?vue&type=template&id=78c236c4&scoped=true"
import script from "./MatchingLedgerItem.vue?vue&type=script&lang=js"
export * from "./MatchingLedgerItem.vue?vue&type=script&lang=js"
import style0 from "./MatchingLedgerItem.vue?vue&type=style&index=0&id=78c236c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c236c4",
  null
  
)

export default component.exports